import DuckEntity from './DuckEntity';

export default function FilteredContactList(nameOrDuck, options = {}) {
  const duck = new DuckEntity(nameOrDuck, options);

  const reducer = (state = duck.initialState, action) => {
    switch (action.type) {
      case duck.types.LOAD_SUCCESS:
        const { payload: { result: { meta: { additional_fields, total, per_page: perPage, search } } } } = action;
        const result = {
          ...duck.reducer(state, action)
        };

        result[action.stateKey].additionalFields = additional_fields;
        result[action.stateKey].perPage = perPage;
        result[action.stateKey].search = search;
        result[action.stateKey].total = total;

        return result;

      default:
        return duck.reducer(state, action);
    }
  };

  const all = (state, stateKey = '_all') => {
    const result = duck.all(state, stateKey);

    if (state[duck.name][stateKey]) {
      const { additionalFields, perPage, search, total } = state[duck.name][stateKey];

      result.additionalFields = additionalFields;
      result.perPage = perPage;
      result.search = search;
      result.total = total;
    }

    return result;
  };

  return {
    ...duck,
    reducer,
    all
  }
}
